<template>
    <div>
        <div class="mainTitle text-center my-3">
            <h5>{{$t('Notification')}}</h5>
        </div> 
        <div class="CustomBlockWidth inMiddle-area whitebox p-4 ">
            <div class="customDropdownBox notificationlist" v-if="userNotify != ''">
                <div class="d-flex align-items-center dropdownList" v-for="list in userNotify" >
                    <div class="usericon">
                        <feather type="mail" size="1rem"></feather>
                    </div> 
                    <div @click="notifyFunc(list)" class="right d-flex align-items-center justify-content-between w-100">
                        <p @click="notifyFunc(list)">{{list.message}}</p>
                        <div class="d-block time">{{list.created_on | moment("DD MMMM YYYY")}}</div>
                    </div> 
                </div>
            </div>  
            <div class="text-center" v-else>
                <img src="../../../../static/fxView/images/noticket.svg" alt="No Notification" class="mb-2 w-25">
                <p> {{$t('noNewNotification')}}</p>
            </div> 
             
        </div>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'profile',
        mixins: [fxViewMixins],
        data() {
            return {}
        },
        methods:{
            notifyFunc(getList){
                if(getList.notification_type == 'TICKET'){
                    this.$router.replace({ name: "fxView.view",query:{id:getList.ticket_id}}) 
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/user_notification.vue